"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _project = require("@/api/project/project");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      form: {
        stageName: "",
        beginTime: "",
        endTime: "",
        expertScoreEndTime: "",
        id: this.$route.query.id,
        matchId: this.$route.query.matchId
      },
      rules: {
        stageName: [{
          required: true,
          message: "请输入阶段名称",
          trigger: "blur"
        }],
        beginTime: [{
          required: true,
          message: "请选择阶段项目阶段开始时间",
          trigger: "blur"
        }],
        endTime: [{
          required: true,
          message: "请选择阶段项目阶段结束时间",
          trigger: "blur"
        }],
        expertScoreEndTime: [{
          required: true,
          message: "请选择专家评分时间",
          trigger: "blur"
        }]
      },
      value1: []
    };
  },
  methods: {
    submit: function submit(v) {
      var _this = this;
      this.$refs[v].validate(function (valid) {
        if (valid) {
          console.log(_this.form, 'form');
          (0, _project.changeStage)(_this.form).then(function (res) {
            if (res.code === 2000) {
              _this.$message.success("操作成功。");
              history.go(-1);
            } else {
              _this.$message.error("操作失败。");
            }
          });
        }
      });
      // e.id = this.$route.query.id;
      // e.matchId = this.$route.query.matchId;
      // changeStage(e).then(res => {
      //   if (res.code === 2000) {
      //     this.$message.success("操作成功。");
      //     history.go(-1);
      //   } else {
      //     this.$message.error("操作失败。");
      //   }
      // });
    },
    // 通过阶段id获取阶段信息
    getInfoByStageId: function getInfoByStageId() {
      var _this2 = this;
      (0, _project.getStageEditInfo)({
        stageId: this.$route.query.id
      }).then(function (res) {
        var data = res.data;
        _this2.form.stageName = data.stageName;
        _this2.form.expertScoreEndTime = data.expertScoreEndTime;
        _this2.form.beginTime = data.beginTime;
        _this2.form.endTime = data.endTime;
      });
    },
    isBack: function isBack() {
      history.go(-1);
    }
  },
  created: function created() {
    this.getInfoByStageId();
  }
};